(function() {
  window.adConfigs = window.adConfigs || {};

  const coffeeImages = {
    'caramel':      null,
    'peanutbutter': 'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Coffee-peanutbutter-habit.png?v=1776936757',
    'pistachio':    null,
    'raspberry':    null,
    'pretzel':      'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Habit-Coffee-Hazelnut-PDP.png?v=1775637624',
    'smaltz':       null,
    'dollarleaningoncup': 'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Habit_Coffee_Dollar_Leans_on_Cup.png?v=1777473589',
    'dollaronbrownspeckledcup': 'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Coffee_resting_on_cup_with_brown_rim_PDP.png?v=1777475146',
    'dollaroncuponsofa': 'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Dollar_on_cup_on_sofa.png?v=1777475750',
    'dollaronwavyrimcup': 'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/dollar_on_wavy_rim_cup.png?v=1777476269',
    'coffeepaperbasiccupbox': 'https://cdn.shopify.com/s/files/1/0869/7387/4512/files/Cup_paper_box.png?v=1777980569',
  };

  const coffeeFlavours = {
    'caramel':      'Caramel',
    'peanutbutter': 'Peanut Butter',
    'pistachio':    'Pistachio',
    'raspberry':    'Raspberry',
    'pretzel':      'Hazelnut',
    'smaltz':       'Malt Cornflakes',
    'dollarleaningoncup': 'Caramel',
    'dollaronbrownspeckledcup': 'Caramel',
    'dollaroncuponsofa': 'Caramel',
    'dollaronwavyrimcup': 'Caramel',
    'coffeepaperbasiccupbox': 'Caramel',
  };

  const subtitle = 'For your coffee moment';
  const socialProof = '★★★★★ Perfect with a coffee';

  Object.entries(coffeeFlavours).forEach(([key, displayName]) => {
    const pdpImage = coffeeImages[key];
    // No cart image change for build a box
    window.adConfigs[`coffee-bab-${key}`] = {
      subtitle,
      heroImage: pdpImage,
      cartImage: null,
      socialProof,
      flavour: displayName,
    };
  });
})();